import { makeStyles } from '@mui/styles';

import Button from '@classify/react-core-components/Button';

const useStyles = makeStyles(
  /* istanbul ignore next */ ({ palette }) => ({
    root: {
      display: 'flex',
      textAlign: 'center',
      '&::before, &::after': {
        content: "''",
        borderBottom: `1px solid ${palette.layout.line.divider}`,
        flexGrow: 1,
        transform: 'translateY(-50%)',
      },
    },
  })
);

export default function LoadMoreButton(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Button {...props} variant="tertiary" />
    </div>
  );
}
